module.exports = __webpack_public_path__ + "img/marker-icon-2x-red.07aea9c9.png";